import { createMongoAbility } from '@casl/ability';

export const createAbilityForUser = (abilities) => {
  return createMongoAbility(abilities);
};

export const isAllowed = (requiredPermissions, ability) => {
  // No ability means nothing has been granted — a signed out user, or a store
  // that has just been cleared on log out. Callers render during that teardown,
  // so this has to answer "no" rather than throw.
  if (!ability) {
    return false;
  }

  return requiredPermissions.every((permission) => ability.can(...permission));
};
